export var cardStyles = {
    root: function () {
        return {
            borderRadius: "4px",
        };
    },
};
//# sourceMappingURL=card-styles.js.map